import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import {
  DISCOUNT_CODE_PATH,
  NEW_DISCOUNT_CODE_PATH,
} from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { DISCOUNT_CODE_COLUMNS } from '../../../../config/columns';
import {
  clearDiscountCodes,
  getDiscountCodes,
} from '../../../../actions/sales/DiscountCode';

export const DiscountCodes = ({
  breadcrumbs,
  discountCodes,
  loading,
  dispatchGetDiscountCodes,
  dispatchClearDiscountCodes,
}) => {
  useLayoutEffect(() => () => dispatchClearDiscountCodes(), []);

  const data = discountCodes.get('content') || [];
  const pages = discountCodes.get('totalPages') || null;
  const defaultPageSize = discountCodes.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Códigos de Descuento"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_DISCOUNT_CODE_PATH}
      tableStructure={{
        columns: DISCOUNT_CODE_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetDiscountCodes,
        modelPath: DISCOUNT_CODE_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetDiscountCodes: getDiscountCodes,
  dispatchClearDiscountCodes: clearDiscountCodes,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Códigos de Descuento',
      href: DISCOUNT_CODE_PATH,
    },
  ],
  discountCodes: SalesUnit.DiscountCode.getIn(['all', 'content']),
  loading: SalesUnit.DiscountCode.getIn(['all', 'loading']),
});

DiscountCodes.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  discountCodes: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetDiscountCodes: PropTypes.func.isRequired,
  dispatchClearDiscountCodes: PropTypes.func.isRequired,
};

DiscountCodes.defaultProps = {
  discountCodes: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountCodes);
